import { Link } from 'gatsby'
import React from 'react'
import './desktop-second-menu.scss'

interface DesktopSecondMenuProps {
  menu?: {
    title: string
    url: string
  }[]
}
export const DesktopSecondMenu = ({ menu }: DesktopSecondMenuProps) => {
  if (!menu || menu.length === 0) return null

  return (
    <div className="second-menu grid-content-full">
      <div className="grid-content">
        {menu?.map((item: { title: string; url: string }, index) => (
          <Link
            className="link-bottom-submenu"
            key={item.title}
            to={item?.url?.toLocaleLowerCase() ?? '/'}
            data-testid={`menu-second-${index}`}
          >
            {item?.title}
          </Link>
        ))}
      </div>
    </div>
  )
}
